import type { FlightExplorerOffer, FlightSearchFailureCause, LegFailure } from './search_source.js';
import type { ExplorerLegPhase } from './explorer_state.js';

/* Leitores da fase de uma perna do explorer — fora de `explorer_state.ts` pelo
   teto de linhas dele; puros, sem regra própria além do que cada doc diz. */

/** A semente é lista de VERDADE (eixos, teto de política e escada rodam sobre
 *  ela enquanto a busca não pousa) — por isso `seeded` entra aqui junto de
 *  `ready`. Quem distingue as duas é `explorerRefreshing`, não este seletor. */
export const offersOf = (leg: ExplorerLegPhase | undefined): FlightExplorerOffer[] =>
  leg?.phase === 'ready' || leg?.phase === 'seeded' ? leg.offers : [];

/** O teto do conjunto que a perna aprendeu num refine — ver `ceiling` em `ready`. */
export const ceilingOfLeg = (leg: ExplorerLegPhase | undefined): number | undefined =>
  leg?.phase === 'ready' ? leg.ceiling : undefined;

/** Append de página: dedupe por offerId (o servidor reusa o id de uma oferta
 *  já vista — mesma regra do refine por departingKey e do hotel por hotelId).
 *  O `seen` acumula TAMBÉM os aceitos da própria página: um id repetido dentro
 *  da mesma resposta entraria duas vezes, e chave duplicada de lista React é
 *  exatamente o tipo de bug que só aparece em produção. */
export const mergeOffers = (
  current: FlightExplorerOffer[],
  incoming: FlightExplorerOffer[],
): FlightExplorerOffer[] => {
  const merged = [...current];
  const seen = new Set(current.map((offer) => offer.offerId));
  for (const offer of incoming) {
    if (seen.has(offer.offerId)) continue;
    seen.add(offer.offerId);
    merged.push(offer);
  }
  return merged;
};

/** A falha da perna que a causa da rejeição carrega — vazia na falha genérica. */
export const legFailureOf = (
  cause: FlightSearchFailureCause | undefined,
): { failure?: LegFailure } =>
  cause === 'timeout' || cause === 'policy_evaluation' || cause === 'search_expired'
    ? { failure: cause }
    : {};
